import { useGetCompanyMenusDataQuery } from '../../../store/api-slices';
import { useSelector } from 'react-redux';
import { selectCompanyId } from '../../../store/slices/InitialDataSlice';
import { CompanyMenusData } from '../../../services/exports/Interfaces';

const useGetCompanyMenusApi = (
  companyId: number = null,
  options: Parameters<typeof useGetCompanyMenusDataQuery>[1] = {},
) => {
  const defaultCompanyId = useSelector(selectCompanyId);
  const id = companyId ?? defaultCompanyId;

  return useGetCompanyMenusDataQuery<Record<string, CompanyMenusData>>(id, {
    skip: !id,
    ...options,
    refetchOnFocus: true,
  });
};

export default useGetCompanyMenusApi;
